const LOCAL_IMAGE_PREFIX = '/uploads/images/';

export const publicImageThumbnail = (value: string | undefined, width: number): string => {
    const raw = String(value || '').trim();
    if (!raw || !Number.isFinite(width) || width < 32) return raw;

    try {
        const parsed = new URL(raw, window.location.origin);
        if (parsed.origin === window.location.origin && parsed.pathname.startsWith(LOCAL_IMAGE_PREFIX)) {
            return `/api/public/media-thumbnail?src=${encodeURIComponent(parsed.pathname)}&width=${Math.round(width)}`;
        }
    } catch {
        return raw;
    }

    return raw;
};

export const reviewAvatarImage = (value: string | undefined, size = 80): string => {
    const raw = String(value || '').trim();
    if (!raw) return '';

    try {
        const parsed = new URL(raw);
        if (parsed.hostname === 'images.unsplash.com') {
            const boundedSize = Math.max(48, Math.min(160, Math.round(size)));
            parsed.searchParams.set('auto', 'format');
            parsed.searchParams.set('fit', 'crop');
            parsed.searchParams.set('crop', 'faces');
            parsed.searchParams.set('w', String(boundedSize));
            parsed.searchParams.set('h', String(boundedSize));
            parsed.searchParams.set('q', '60');
            return parsed.toString();
        }
    } catch {
        return raw;
    }

    return raw;
};
